import { render, staticRenderFns } from "./number-tag-input.generic.vue?vue&type=template&id=763c95d5&scoped=true&"
import script from "./number-tag-input.generic.vue?vue&type=script&lang=js&"
export * from "./number-tag-input.generic.vue?vue&type=script&lang=js&"
import style0 from "./number-tag-input.generic.vue?vue&type=style&index=0&id=763c95d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c95d5",
  null
  
)

export default component.exports